import React from 'react';
import PropTypes from 'prop-types';

export const Typography = ({children, className, content, TagName}) => {
    return (
        <TagName data-testid="typography" className={className}>
            {content}
            {children}
        </TagName>
    );
};

Typography.Proptypes = {
    children: PropTypes.element,
    className: PropTypes.string,
    content: PropTypes.string.isRequired,
    TagName: PropTypes.string.isRequired,
};
